import React, { Suspense } from 'react';
import * as api from '../api/index';
import Video from '../components/Video/Video';
import useAxiosData from '../hooks/useAxiosData';

/**
 * Renders a page of videos.
 * @param {Object} props The component properties.
 * @param {string} props.title The page title.
 * @param {string} props.description The page description.
 * @param {string[] | undefined} props.categories The video categories to include. Includes all categories if not specified.
 * @param {string[] | undefined} props.subcategories The video subcategories to include. Includes all subcategories if not specified.
 * @returns {import('react').ReactNode}
 */
export default function VideoPage({ title, description, categories, subcategories }) {
    const [videos, status] = useAxiosData(api.fetchVideos, []);
    const filteredVideos = videos.filter(video => (!categories || categories.includes(video.category)) && (!subcategories || subcategories.includes(video.subCategory)));

    return (
        <section className="container mt-5">
            <div className="text-center mb-4">
                <h1>{title}</h1>
                <p>{description}</p>
            </div>

            {status === "loading" ? 
                <div className="text-center">
                <p>Loading videos...</p> 
                </div> : 
                <div className="row g-4 justify-content-center">
                {filteredVideos.map(video => (<Video {...video} key={video._id} />))}
            </div>}
        </section>
    );
}